import fetch from './../fetch';

import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'orgName', label: '授权部门', width: 150},
    {key:'employeeName', label: '教师姓名'},
    {key:'employeeCode', label: '职工编号'},
    {key:'termName', label: '所属学期'}
    
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const params = [];
    for (var i in keywords) {
        params.push(`${i}=${keywords[i] || ''}`)
    }
    
    return fetch.get('teacher/teaching/quality/org/auth/query?'+ params.join('&'))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('teacher/teaching/quality/org/auth/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const queryTerm = () => {
    return fetch.post('term/term/list')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    }) 
}

const copy = (copyTermId) => {
    return fetch.get(`teacher/teaching/quality/org/auth/copy/${copyTermId}`)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    }) 
}

export default {
    querySearch,
    columns,
    onSelect,
    remove,
    setRefresh,
    getSelection,
    queryTerm,
    copy
}